import { CalendarToday, Stars } from '@mui/icons-material';
import { Grid, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { DateTime } from 'luxon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { fromDBToLocalTimestamp } from '../helpers/date';

const PREFIX = 'WoIndicators';

const classes = {
  grid: `${PREFIX}-grid`,
  warning: `${PREFIX}-warning`,
  requests: `${PREFIX}-requests`,
  indicator: `${PREFIX}-indicator`,
};

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`&.${classes.grid}`]: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    flexWrap: 'nowrap',
    [theme.breakpoints.between('sm', 'md')]: {
      flexDirection: 'column',
    },
  },

  [`& .${classes.warning}`]: {
    color: theme.palette.error.main,
  },

  [`& .${classes.requests}`]: {
    color: theme.palette.info.main,
    height: ({ isMobile }) => (isMobile ? null : '35px'),
    width: ({ isMobile }) => (isMobile ? null : '35px'),
  },

  [`& .${classes.indicator}`]: {
    marginLeft: '10px',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.between('sm', 'md')]: {
      marginBottom: theme.spacing(1),
    },
  },
}));

const WoIndicators = ({ specialRequests, promiseDate }) => {
  const { t } = useTranslation('workOrdersTable');
  return (
    <StyledGrid container className={classes.grid}>
      {specialRequests?.length ? (
        <Grid item className={classes.indicator}>
          <Tooltip
            arrow
            title={`${specialRequests.length} ${t('card.specialRequest')}`}
            placement={'bottom'}
          >
            <Stars data-testid="specialRequest" className={classes.requests} />
          </Tooltip>
        </Grid>
      ) : null}
      {promiseDate ? (
        <Grid item className={classes.indicator}>
          <Tooltip
            arrow
            title={`${t('card.promiseDate')} \r\n ${fromDBToLocalTimestamp(
              promiseDate,
              DateTime.DATETIME_SHORT
            )} `}
            placement={'bottom'}
            PopperProps={{
              sx: {
                whiteSpace: 'pre-line',
              },
            }}
          >
            <CalendarToday
              data-testid="promiseDate"
              className={classes.requests}
            />
          </Tooltip>
        </Grid>
      ) : null}
    </StyledGrid>
  );
};

export default WoIndicators;
